// src/studio/avatar/utils/exportAvatarPng.js

const EXPORT_SIZE = 512;
const MAX_PNG_BYTES = 2 * 1024 * 1024;

export async function exportAvatarPng(svgElement) {
  if (
    !svgElement ||
    svgElement.localName !== 'svg' ||
    svgElement.namespaceURI !== 'http://www.w3.org/2000/svg'
  ) {
    throw new Error('Avatar preview is not ready. Please try again.');
  }

  const copy = svgElement.cloneNode(true);

  copy.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  copy.setAttribute('width', String(EXPORT_SIZE));
  copy.setAttribute('height', String(EXPORT_SIZE));

  // Remove responsive preview styling from the export copy.
  copy.removeAttribute('class');
  copy.style.removeProperty('max-width');
  copy.style.width = `${EXPORT_SIZE}px`;
  copy.style.height = `${EXPORT_SIZE}px`;

  const svgText = new XMLSerializer().serializeToString(copy);
  const svgBlob = new Blob([svgText], {
    type: 'image/svg+xml;charset=utf-8',
  });

  const objectUrl = URL.createObjectURL(svgBlob);

  try {
    const image = await new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => resolve(img);
      img.onerror = () =>
        reject(new Error('Could not render the avatar for export.'));

      img.src = objectUrl;
    });

    const canvas = document.createElement('canvas');
    canvas.width = EXPORT_SIZE;
    canvas.height = EXPORT_SIZE;

    const context = canvas.getContext('2d');

    if (!context) {
      throw new Error('Image export is unavailable in this browser.');
    }

    context.drawImage(
      image,
      0,
      0,
      EXPORT_SIZE,
      EXPORT_SIZE
    );

    const png = await new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Could not create the avatar PNG.'));
          return;
        }

        resolve(blob);
      }, 'image/png');
    });

    if (png.size > MAX_PNG_BYTES) {
      throw new Error('Avatar PNG exceeds the 2 MB upload limit.');
    }

    return png;
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
